
import React, { useState } from 'react';
import { Text, View, StyleSheet, TouchableOpacity, TextInput, KeyboardAvoidingView, Platform, ScrollView, I18nManager, Alert } from "react-native";
import Icon from '../components/Icon';
import { useRouter } from "expo-router";
import { useAuth } from '../context/AuthContext';
import { nativeAuthStyles } from '../../styles/native.styles';

export default function NativeAuth() {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({
    email: false,
    password: false,
    confirmPassword: false,
    name: false,
  });
  const [errorMessages, setErrorMessages] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: '',
  });

  const router = useRouter();
  const { signIn, signUp, signInWithGoogle, signInWithTwitter, isLoading } = useAuth();

  // التحقق من صحة البريد الإلكتروني
  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // التحقق من قوة كلمة المرور
  const validatePassword = (password: string) => {
    const minLength = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    
    return {
      isValid: minLength && hasUpperCase && hasLowerCase && hasNumbers,
      minLength,
      hasUpperCase,
      hasLowerCase,
      hasNumbers,
      hasSpecialChar
    };
  };

  // التحقق من صحة الاسم
  const validateName = (name: string) => {
    return name.trim().length >= 2 && /^[a-zA-Zأ-ي\s]+$/.test(name);
  };

  const handleLogin = async () => {
    const newErrors = {
      email: !email || !validateEmail(email),
      password: !password || password.length < 6,
      confirmPassword: false,
      name: false,
    };

    const newErrorMessages = {
      email: !email ? 'البريد الإلكتروني مطلوب' : 
             !validateEmail(email) ? 'تنسيق البريد الإلكتروني غير صحيح' : '',
      password: !password ? 'كلمة المرور مطلوبة' : 
                password.length < 6 ? 'كلمة المرور يجب أن تكون 6 أحرف على الأقل' : '',
      confirmPassword: '',
      name: '',
    };

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);

    if (newErrors.email || newErrors.password) {
      const errorMessage = newErrorMessages.email || newErrorMessages.password;
      Alert.alert('خطأ في التحقق', errorMessage);
      return;
    }

    try {
      await signIn(email, password);
      router.replace('/home');
    } catch (error: any) {
      Alert.alert('خطأ', error.message || 'فشل في تسجيل الدخول');
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      console.log('بدء تسجيل الدخول بـ Google...');
      await signInWithGoogle();
      router.replace('/home');
    } catch (error: any) {
      if (error?.code === 'auth/popup-closed-by-user') {
        return;
      }
      console.error('Google Sign In Error:', error);
      Alert.alert('خطأ', 'فشل في تسجيل الدخول بـ Google');
    }
  };

  const handleTwitterSignIn = async () => {
    try {
      console.log('Twitter Sign In');
      await signInWithTwitter();
      router.replace('/home');
    } catch (error: any) {
      if (error?.code === 'auth/popup-closed-by-user') {
        return;
      }
      console.error('Twitter Sign In Error:', error);
      Alert.alert('خطأ', 'فشل في تسجيل الدخول بـ Twitter');
    }
  };

  const handleRegister = async () => {
    console.log('📱 [NATIVE-REGISTER] بدء دالة handleRegister...');
    console.log('📱 [NATIVE-REGISTER] البيانات المُدخلة:', {
      name: name,
      email: email,
      passwordLength: password.length,
      confirmPasswordLength: confirmPassword.length,
      nameLength: name.length,
      emailLength: email.length
    });

    const passwordValidation = validatePassword(password);
    console.log('📱 [NATIVE-REGISTER] نتيجة التحقق من كلمة المرور:', passwordValidation);
    
    const newErrors = {
      name: !name || !validateName(name),
      email: !email || !validateEmail(email),
      password: !password || !passwordValidation.isValid,
      confirmPassword: !confirmPassword || password !== confirmPassword,
    };
    
    console.log('📱 [NATIVE-REGISTER] الأخطاء المكتشفة:', newErrors);

    const newErrorMessages = {
      name: !name ? 'الاسم مطلوب' : 
            !validateName(name) ? 'الاسم يجب أن يحتوي على حروف فقط وأن يكون أكثر من حرفين' : '',
      email: !email ? 'البريد الإلكتروني مطلوب' : 
             !validateEmail(email) ? 'تنسيق البريد الإلكتروني غير صحيح' : '',
      password: !password ? 'كلمة المرور مطلوبة' : 
                !passwordValidation.isValid ? 'كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل، حروف كبيرة وصغيرة، وأرقام' : '',
      confirmPassword: !confirmPassword ? 'تأكيد كلمة المرور مطلوب' : 
                       password !== confirmPassword ? 'كلمات المرور غير متطابقة' : '',
    };
    
    console.log('📱 [NATIVE-REGISTER] رسائل الأخطاء:', newErrorMessages);

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);

    // التحقق من وجود أي أخطاء حقيقية (ليس فقط الحقول الفارغة)
    const hasErrors = Object.values(newErrors).some(error => error === true);
    console.log('📱 [NATIVE-REGISTER] هل يوجد أخطاء؟', hasErrors);
    
    if (hasErrors) {
      const firstError = newErrorMessages.name || newErrorMessages.email || 
                        newErrorMessages.password || newErrorMessages.confirmPassword;
      console.log('❌ [NATIVE-REGISTER] تم العثور على خطأ في التحقق:', firstError);
      Alert.alert('خطأ في التحقق', firstError);
      return;
    }
    
    console.log('✅ [NATIVE-REGISTER] لا توجد أخطاء، المتابعة لإنشاء الحساب...');

    try {
      console.log('🚀 [NATIVE-REGISTER] استدعاء signUp...', { 
        email, 
        name, 
        passwordLength: password.length 
      });
      
      const result = await signUp(email, password, name);
      
      console.log('✅ [NATIVE-REGISTER] نتيجة إنشاء الحساب:', result);
      console.log('🏠 [NATIVE-REGISTER] الانتقال للصفحة الرئيسية...');
      console.log('🏠 [NATIVE-REGISTER] استدعاء router.replace("/home")...');
      
      router.replace('/home');
      
      console.log('✅ [NATIVE-REGISTER] تم استدعاء router.replace بنجاح');
      
    } catch (error: any) {
      console.error('💥 [NATIVE-REGISTER] خطأ في إنشاء الحساب:', error);
      console.error('💥 [NATIVE-REGISTER] تفاصيل الخطأ:', {
        message: error.message,
        code: error.code,
        stack: error.stack
      });
      Alert.alert('خطأ', error.message || 'فشل في إنشاء الحساب');
    }
  };

  return (
    <KeyboardAvoidingView style={nativeAuthStyles.container} behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
      <ScrollView contentContainerStyle={nativeAuthStyles.scrollContainer} keyboardShouldPersistTaps="handled">
        <View style={nativeAuthStyles.header}>
          <Text style={nativeAuthStyles.title}>
            {isLogin ? 'تسجيل الدخول' : 'إنشاء حساب جديد'}
          </Text>
          <Text style={nativeAuthStyles.subtitle}>
            {isLogin ? 'مرحباً بعودتك' : 'انضم إلينا اليوم'}
          </Text>
        </View>

        <View style={nativeAuthStyles.form}>
          <View style={nativeAuthStyles.topFooter}>
            <View style={nativeAuthStyles.footerContainer}>
              <TouchableOpacity 
                style={nativeAuthStyles.switchButton}
                onPress={() => setIsLogin(!isLogin)}
              >
                <Text style={nativeAuthStyles.switchButtonText}>
                  {isLogin ? 'إنشاء حساب' : 'تسجيل الدخول'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
          {!isLogin && (
            <View style={[nativeAuthStyles.inputContainer, name && nativeAuthStyles.inputContainerFocused]}>
              <Icon 
                name="user" 
                size={20} 
                color={errors.name ? "#ff4757" : (name ? "#4A9EFF" : "#666")} 
                style={[nativeAuthStyles.inputIcon, name && nativeAuthStyles.inputIconFocused]} 
              />
              <TextInput
                style={nativeAuthStyles.input}
                placeholder="الاسم الكامل"
                value={name}
                onChangeText={(text) => {
                  setName(text);
                  if (text && validateName(text)) {
                    setErrors(prev => ({...prev, name: false}));
                    setErrorMessages(prev => ({...prev, name: ''}));
                  } else if (text) {
                    setErrors(prev => ({...prev, name: true}));
                    setErrorMessages(prev => ({...prev, name: 'الاسم يجب أن يحتوي على حروف فقط وأن يكون أكثر من حرفين'}));
                  }
                }}
                placeholderTextColor="#999"
              />
            </View>
          )}

          <View style={[nativeAuthStyles.inputContainer, email && nativeAuthStyles.inputContainerFocused]}>
            <Icon 
              name="email" 
              size={20} 
              color={errors.email ? "#ff4757" : (email ? "#4A9EFF" : "#666")}
              style={[nativeAuthStyles.inputIcon, email && nativeAuthStyles.inputIconFocused]} 
            />
            <TextInput
              style={nativeAuthStyles.input}
              placeholder="البريد الإلكتروني"
              value={email}
              onChangeText={(text) => {
                setEmail(text);
                if (text && validateEmail(text)) {
                  setErrors(prev => ({...prev, email: false}));
                  setErrorMessages(prev => ({...prev, email: ''}));
                } else if (text) {
                  setErrors(prev => ({...prev, email: true}));
                  setErrorMessages(prev => ({...prev, email: 'تنسيق البريد الإلكتروني غير صحيح'}));
                }
              }}
              keyboardType="email-address"
              autoCapitalize="none"
              placeholderTextColor="#999"
            />
          </View>

          <View style={[nativeAuthStyles.inputContainer, password && nativeAuthStyles.inputContainerFocused]}>
            <Icon 
              name="lock" 
              size={20} 
              color={errors.password ? "#ff4757" : (password ? "#4A9EFF" : "#666")} 
              style={[nativeAuthStyles.inputIcon, password && nativeAuthStyles.inputIconFocused]} 
            />
            <TextInput
              style={nativeAuthStyles.input}
              placeholder="كلمة المرور"
              value={password}
              onChangeText={(text) => {
                setPassword(text);
                const passwordValidation = validatePassword(text);
                if (text && (isLogin ? text.length >= 6 : passwordValidation.isValid)) {
                  setErrors(prev => ({...prev, password: false}));
                  setErrorMessages(prev => ({...prev, password: ''}));
                } else if (text) {
                  setErrors(prev => ({...prev, password: true}));
                  if (isLogin) {
                    setErrorMessages(prev => ({...prev, password: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل'}));
                  } else {
                    setErrorMessages(prev => ({...prev, password: 'كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل، حروف كبيرة وصغيرة، وأرقام'}));
                  }
                }
                if (confirmPassword && text === confirmPassword) {
                  setErrors(prev => ({...prev, confirmPassword: false}));
                  setErrorMessages(prev => ({...prev, confirmPassword: ''}));
                } else if (confirmPassword) {
                  setErrors(prev => ({...prev, confirmPassword: true}));
                  setErrorMessages(prev => ({...prev, confirmPassword: 'كلمات المرور غير متطابقة'}));
                }
              }}
              secureTextEntry={!showPassword}
              placeholderTextColor="#999"
            />
            <TouchableOpacity onPress={() => setShowPassword(!showPassword)}>
              <Icon
                name={showPassword ? "eye" : "eye-off"}
                size={20}
                color="#666"
              />
            </TouchableOpacity>
          </View>

          {!isLogin && (
            <View style={[nativeAuthStyles.inputContainer, confirmPassword && nativeAuthStyles.inputContainerFocused]}>
              <Icon 
                name="lock" 
                size={20} 
                color={errors.confirmPassword ? "#ff4757" : (confirmPassword ? "#4A9EFF" : "#666")} 
                style={[nativeAuthStyles.inputIcon, confirmPassword && nativeAuthStyles.inputIconFocused]} 
              />
              <TextInput
                style={nativeAuthStyles.input}
                placeholder="تأكيد كلمة المرور"
                value={confirmPassword}
                onChangeText={(text) => {
                  setConfirmPassword(text);
                  if (text && text === password) {
                    setErrors(prev => ({...prev, confirmPassword: false}));
                    setErrorMessages(prev => ({...prev, confirmPassword: ''}));
                  } else if (text) {
                    setErrors(prev => ({...prev, confirmPassword: true}));
                    setErrorMessages(prev => ({...prev, confirmPassword: 'كلمات المرور غير متطابقة'}));
                  }
                }}
                secureTextEntry={!showConfirmPassword}
                placeholderTextColor="#999"
              />
              <TouchableOpacity onPress={() => setShowConfirmPassword(!showConfirmPassword)}>
                <Icon
                  name={showConfirmPassword ? "eye" : "eye-off"}
                  size={20}
                  color="#666"
                />
              </TouchableOpacity>
            </View>
          )}

          {isLogin && (
            <View style={nativeAuthStyles.optionsContainer}>
              <TouchableOpacity
                style={nativeAuthStyles.rememberMeContainer}
                onPress={() => setRememberMe(!rememberMe)}
                activeOpacity={0.7}
              >
                <View style={[
                  nativeAuthStyles.circularCheckbox,
                  rememberMe && nativeAuthStyles.circularCheckboxChecked
                ]}>
                  {rememberMe && (
                    <Icon
                      name="check"
                      size={12}
                      color="#ffffff"
                      style={{ fontWeight: 'bold' }}
                    />
                  )}
                </View>
                <Text style={nativeAuthStyles.rememberMeText}>تذكرني</Text>
              </TouchableOpacity>

              <TouchableOpacity activeOpacity={0.7}>
                <Text style={nativeAuthStyles.forgotPasswordText}>نسيت كلمة المرور؟</Text>
              </TouchableOpacity>
            </View>
          )}

          <TouchableOpacity
            style={[nativeAuthStyles.primaryButton, isLoading && { opacity: 0.6 }]}
            onPress={isLogin ? handleLogin : handleRegister}
            disabled={isLoading}
          >
            <Text style={nativeAuthStyles.primaryButtonText}>
              {isLogin ? 'تسجيل الدخول' : 'إنشاء حساب'}
            </Text>
          </TouchableOpacity>

          <View style={nativeAuthStyles.divider}>
            <View style={nativeAuthStyles.dividerLine} />
            <Text style={nativeAuthStyles.dividerText}>أو</Text>
            <View style={nativeAuthStyles.dividerLine} />
          </View>

          <View style={nativeAuthStyles.socialButtonsContainer}>
            <View style={{ alignItems: 'center' }}>
              <TouchableOpacity
                style={[nativeAuthStyles.socialButton, isLoading && { opacity: 0.6 }]}
                onPress={handleGoogleSignIn}
                disabled={isLoading}
              >
                <Icon name="google" size={24} color="#4A9EFF" />
              </TouchableOpacity>
              <Text style={{ fontSize: 12, color: '#b0b0b0', fontWeight: '500', marginTop: 8 }}>Google</Text>
            </View>

            <View style={{ alignItems: 'center' }}>
              <TouchableOpacity
                style={[nativeAuthStyles.socialButton, isLoading && { opacity: 0.6 }]}
                onPress={handleTwitterSignIn}
                disabled={isLoading}
              >
                <Text style={{ fontSize: 20, color: '#4A9EFF', fontWeight: 'bold' }}>𝕏</Text>
              </TouchableOpacity>
              <Text style={{ fontSize: 12, color: '#b0b0b0', fontWeight: '500', marginTop: 8 }}>X</Text>
            </View>
          </View>
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}


